<script setup>
import { ref, computed, toRefs } from 'vue';
import AppApiInfoCodeBlock from './ApiInfoCodeBlock.vue';

import { useNpmData } from '@/composables/actions/useNpmData';
const {
  installationInstructionsNpm,
  installationInstructionsYarn,
  initializationInstructions,
  getQueryInstructions,
  getQueryTitle,
} = useNpmData();

const props = defineProps({
  query: {
    type: Object,
    required: true,
  },
  projectId: {
    type: String,
  },
  variables: {
    type: Object,
    required: false,
  },
});

const { query, variables: variable } = toRefs(props);

const variables = computed(() => {
  if (variable.value) {
    return { ...variable.value, payload: payloadString.value };
  }
  return {};
});

const payloadString = computed(() => {
  const propVariable = variable.value?.payload;
  if (!propVariable) {
    return propVariable;
  }
  const varString = JSON.stringify(
    propVariable,
    (k, v) => (v === undefined ? '__undefined' : v),
    '\t'
  ).replace(/"__undefined"/g, 'undefined');
  return varString;
});

const queryTitle = computed(() => {
  const title = getQueryTitle(query.value);
  return title || 'Query';
});
const queryInstructions = computed(() => {
  return getQueryInstructions(query.value, variables.value);
});

const documentationLink = computed(() => {
  return 'https://www.npmjs.com/package/@cognitivecloud/actions';
});
</script>

<template>
  <div>
    <app-api-info-code-block
      header="NPM install:"
      :code="installationInstructionsNpm"
    />
    <app-api-info-code-block
      header="Yarn add:"
      :code="installationInstructionsYarn"
    />
    <app-api-info-code-block
      header="Initialize:"
      :code="initializationInstructions"
    />
    <app-api-info-code-block
      :header="`${queryTitle}:`"
      :subheader="
        queryTitle === 'RunJob'
          ? 'Example payload variables. Note: `undefined` is not a valid value for payload variables but can appear here to show all accepted properties.'
          : ''
      "
      :code="queryInstructions"
    />
    <div class="flex w-full items-center justify-between gap-2">
      <Button
        as="a"
        :href="documentationLink"
        target="_blank"
        rel="noopener"
        label="Documentation"
        icon="icon-[ph--file-code] text-xl"
        outlined
        fluid
        size="large"
      />
    </div>
  </div>
</template>
